define('models/shared/bankaccount/bankaccount',['backbone'
], function (Backbone) {
    var BankAccount = Backbone.Model.extend({

        url:function(){
            if (this.instanceURL)
                return this.instanceURL;
            else
                return null;
        },
        initialize: function (options) {
            options = options || {};

            this.instanceURL = options.instanceURL;

            this.BankAccountID = options.BID;
            this.AccountID = options.AID;
            this.BankAccountTypeID = options.BTID;
            this.BankName = options.BN;
            this.BankAccountNumber = options.BAN;
            this.BankRoutingNumber = options.RN;
            this.Primary = options.P;
            this.Verified = options.V;
            this.VerifiedDT = options.VDT;
            this.BankAccountStatus = options.BAS;
            this.VerificationStatus = options.VS;
            this.NumberOfAttempts = options.NOA;
            this.DaysForVerification = options.DAV;
            this.DaysOfCreation = options.DOC;
            this.ExtBankAccountId = options.EFID;
            this.ExtBankAccountToken = options.EBAT;
        },
        defaults: {
            NumberOfAttempts:0
        },
        validation: {

        },
        parse: function (data) {
            var response = {};
            if (data) {
                response.BankAccountID = data.BID;
                response.AccountID = data.AID;
                response.BankAccountTypeID = data.BTID;
                response.BankName = data.BN;
                response.BankAccountNumber = data.BAN;
                response.BankRoutingNumber = data.RN;
                response.ExtBankAccountID = data.EFID;
                response.ExtBankAccountToken = data.EBAT;
                response.Primary = data.P;
                response.Verified = data.V;
                response.VerifiedDT = data.VDT;
                response.BankAccountStatus = data.BAS;
                response.VerificationStatus = data.VS;
                response.NumberOfAttempts = data.NOA;
                response.DaysForVerification = data.DAV;
                response.DaysOfCreation = data.DOC;
            }
            return response;
        },
        save: function (attributes, options) {
            options = options || {};
            attributes = attributes || {};;

            var data = {};
            data.BID = this.attributes.BankAccountID;
            data.AID = this.attributes.AccountID;
            data.BTID = this.attributes.BankAccountTypeID;
            data.BN = this.attributes.BankName;
            data.BAN = this.attributes.BankAccountNumber;
            data.RN = this.attributes.BankRoutingNumber;
            data.P = this.attributes.Primary;
            data.V = this.attributes.Verified;
            data.VDT = this.attributes.VerifiedDT;
            data.BAS = this.attributes.BankAccountStatus;
            data.NOA = this.attributes.NumberOfAttempts;
            data.DAV = this.attributes.DaysForVerification;
            data.DOC = this.attributes.DaysOfCreation;
            this.attributes = data;

            return Backbone.Model.prototype.save.call(this, attributes, options);
        }
    });

    return BankAccount;
});

